import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d544a7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row card flat border bg-white p-2" }
const _hoisted_2 = {
  key: 0,
  class: "position-buttons text-primary p-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars field-drag-handle" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_5 = { class: "d-flex flex-row align-items-start" }
const _hoisted_6 = { class: "p-2 flex-grow-1" }
const _hoisted_7 = { class: "m-0 flex-grow-1 font-weight-bold" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "d-flex flex-row" }
const _hoisted_10 = { class: "m-0 mr-2" }
const _hoisted_11 = { class: "flex-shrink-0" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "p-2 m-0 font-weight-bold"
}
const _hoisted_14 = { class: "d-flex flex-row align-items-center" }
const _hoisted_15 = { class: "px-2 m-0 flex-grow-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex-shrink-0" }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_translate = _resolveComponent("translate")!
  const _component_PanelEditorField = _resolveComponent("PanelEditorField", true)!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "pi pi-caret-up",
            style: _normalizeStyle({ opacity: _ctx.index > 0 ? '1' : '0' }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('move-up')))
          }, null, 4),
          _hoisted_3,
          _createElementVNode("i", {
            class: "pi pi-caret-down",
            style: _normalizeStyle({ opacity: _ctx.index < _ctx.count - 1 ? '1' : '0' }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('move-down')))
          }, null, 4)
        ]))
      : _createCommentVNode("", true),
    (_ctx.field.contentType?.toLowerCase() === 'field')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.field.ordinal ? _ctx.field.ordinal + ' ' : '') + _toDisplayString(_ctx.translate(_ctx.field)) + " ", 1),
                (_ctx.field.contentId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(_ctx.field.contentId) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.fieldTypeOptions.find(o => o.type === _ctx.field.displayType)?.name || ''), 1),
                _createVNode(_component_Checkbox, {
                  class: "mr-2",
                  binary: "",
                  modelValue: _ctx.field.repeatable,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.field.repeatable) = $event)),
                  label: _ctx.i18n.$gettext('wiederholbar'),
                  name: "field.repeatable",
                  disabled: _ctx.disabled || _ctx.isEuCopy
                }, null, 8, ["modelValue", "label", "disabled"]),
                _createVNode(_component_Checkbox, {
                  class: "mr-2",
                  binary: "",
                  modelValue: _ctx.field.required,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.field.required) = $event)),
                  label: _ctx.i18n.$gettext('erforderlich'),
                  name: "field.required",
                  disabled: _ctx.disabled || _ctx.isEuCopy
                }, null, 8, ["modelValue", "label", "disabled"]),
                _createVNode(_component_Checkbox, {
                  binary: "",
                  modelValue: _ctx.field.hidden,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.field.hidden) = $event)),
                  label: _ctx.i18n.$gettext('versteckt'),
                  name: "field.required",
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "label", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (!_ctx.disabled && !_ctx.isEuCopy && [ 'CHECKBOX', 'RADIO' ].includes(_ctx.field.displayType))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "mr-2 flat p-button-text",
                    icon: "pi pi-plus",
                    label: _ctx.i18n.$gettext('Feld'),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('add-field', _ctx.field)))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (!_ctx.disabled)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "mr-2 flat p-button-text",
                    icon: "pi pi-pencil",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('start-edit', _ctx.field)))
                  }))
                : _createCommentVNode("", true),
              (!_ctx.disabled && !_ctx.isEuCopy)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    class: "mr-2 flat p-button-text",
                    icon: "pi pi-copy",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('copy-field')))
                  }))
                : _createCommentVNode("", true),
              (!_ctx.disabled && !(_ctx.isEuCopy && _ctx.field.required))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 3,
                    class: "flat p-button-text",
                    icon: "pi pi-trash",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('remove-field')))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          ((_ctx.field.choices || []).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                ([ 'DROPDOWN', 'MULTICHECKBOX', 'COMBOBOX' ].includes(_ctx.field.displayType))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Optionen")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(":")
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.field.choices || []), (choice, k) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, [
                        _createTextVNode("• " + _toDisplayString(choice.name) + " ", 1),
                        (choice.contentId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(" + _toDisplayString(choice.contentId) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        (!_ctx.disabled)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "mr-2 flat p-button-text",
                              icon: "pi pi-plus",
                              label: _ctx.i18n.$gettext('Feld'),
                              onClick: ($event: any) => (_ctx.$emit('add-field-for-choice', choice))
                            }, null, 8, ["label", "onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.disabled)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              class: "mr-2 flat p-button-text",
                              icon: "pi pi-pencil",
                              onClick: ($event: any) => (_ctx.$emit('edit-choice', choice))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.disabled)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 2,
                              class: "mr-2 flat p-button-text",
                              icon: "pi pi-copy",
                              onClick: ($event: any) => (_ctx.field.choices.splice(k, 0, _ctx.copyChoice(choice)))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.disabled)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 3,
                              class: "flat p-button-text",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => (_ctx.field.choices.splice(k, 1))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    ((choice.fields || []).length)
                      ? (_openBlock(), _createBlock(_component_Container, {
                          key: 0,
                          orientation: "vertical",
                          "group-name": "Subfields",
                          "drag-handle-selector": ".subfield-drag-handle",
                          "lock-axis": "y",
                          "drop-placeholder": { className:
                                 `drop-area`,
                               animationDuration: '200',
                               showOnTop: true },
                          "drag-class": "shadow bg-color-lightgray\n            transition duration-100 ease-in\n            transform rotate-3 scale-110",
                          "drop-class": "transition duration-100\n            ease-in z-50 transform\n            -rotate-2 scale-90",
                          "get-child-payload": index => (choice.fields || [])[index],
                          onDrop: (e) => _ctx.onFieldDrop(choice.fields, e)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((choice.fields || []), (subfield, i) => {
                              return (_openBlock(), _createBlock(_component_Draggable, {
                                class: _normalizeClass(["mt-2", { 'mb-2': i === (choice.fields || []).length - 1 }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_PanelEditorField, {
                                    field: subfield,
                                    index: i,
                                    choice: choice,
                                    onAddField: _cache[9] || (_cache[9] = f => _ctx.$emit('add-field', f)),
                                    onStartEdit: _cache[10] || (_cache[10] = f => _ctx.$emit('start-edit', f)),
                                    onEditChoice: _cache[11] || (_cache[11] = c => _ctx.$emit('edit-choice', c)),
                                    onAddFieldForChoice: _cache[12] || (_cache[12] = c => _ctx.$emit('add-field-for-choice', c)),
                                    onCopyField: ($event: any) => (choice?.fields?.splice(i, 0, _ctx.copyPanel(subfield))),
                                    onRemoveField: ($event: any) => (choice?.fields?.splice(i, 1)),
                                    onMoveUp: ($event: any) => (choice?.fields?.splice(Math.max(i - 1, 0), 0, choice?.fields?.splice(i, 1)[0])),
                                    onMoveDown: ($event: any) => (choice?.fields?.splice(Math.min(i + 1, choice?.fields?.length - 1), 0, choice?.fields?.splice(i, 1)[0]))
                                  }, null, 8, ["field", "index", "choice", "onCopyField", "onRemoveField", "onMoveUp", "onMoveDown"])
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            }), 256))
                          ]),
                          _: 2
                        }, 1032, ["get-child-payload", "onDrop"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ]))
            : (_ctx.listEntries.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.listEntry,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.listEntry) = $event)),
                    options: _ctx.listEntries,
                    label: _ctx.i18n.$gettext('Optionen')
                  }, null, 8, ["modelValue", "options", "label"])
                ]))
              : _createCommentVNode("", true),
          ([ 'CHECKBOX', 'RADIO' ].includes(_ctx.field.displayType))
            ? (_openBlock(), _createBlock(_component_Container, {
                key: 2,
                orientation: "vertical",
                "group-name": "Subfields",
                "drag-handle-selector": ".subfield-drag-handle",
                "lock-axis": "y",
                "drop-placeholder": { className:
                                 `drop-area`,
                               animationDuration: '200',
                               showOnTop: true },
                "drag-class": "shadow bg-color-lightgray\n            transition duration-100 ease-in\n            transform rotate-3 scale-110",
                "drop-class": "transition duration-100\n            ease-in z-50 transform\n            -rotate-2 scale-90",
                "get-child-payload": index => (_ctx.field.fields || [])[index],
                onDrop: _cache[18] || (_cache[18] = (e) => _ctx.onFieldDrop(_ctx.field.fields, e))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.field.fields || []), (subfield, i) => {
                    return (_openBlock(), _createBlock(_component_Draggable, {
                      class: _normalizeClass(["mt-2", { 'mb-2': i === (_ctx.field.fields || []).length - 1 }])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PanelEditorField, {
                          field: subfield,
                          index: i,
                          onAddField: _cache[14] || (_cache[14] = f => _ctx.$emit('add-field', f)),
                          onStartEdit: _cache[15] || (_cache[15] = f => _ctx.$emit('start-edit', f)),
                          onEditChoice: _cache[16] || (_cache[16] = c => _ctx.$emit('edit-choice', c)),
                          onAddFieldForChoice: _cache[17] || (_cache[17] = c => _ctx.$emit('add-field-for-choice', c)),
                          onCopyField: ($event: any) => (_ctx.field?.fields?.splice(i, 0, _ctx.copyPanel(subfield))),
                          onRemoveField: ($event: any) => (_ctx.field?.fields?.splice(i, 1)),
                          onMoveUp: ($event: any) => (_ctx.field?.fields?.splice(Math.max(i - 1, 0), 0, _ctx.field?.fields?.splice(i, 1)[0])),
                          onMoveDown: ($event: any) => (_ctx.field?.fields?.splice(Math.min(i + 1, _ctx.field?.fields?.length - 1), 0, _ctx.field?.fields?.splice(i, 1)[0]))
                        }, null, 8, ["field", "index", "onCopyField", "onRemoveField", "onMoveUp", "onMoveDown"])
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["get-child-payload"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}